// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const headerHeightMobile = 60;
export const headerHeight = 90;

